import BaseEntity from '../baseclasses/BaseEntity'
export class EquipmentType extends BaseEntity {
    ID?: number;
    Name?: string;
}

export default EquipmentType;